import React, { useEffect, useState } from "react";
import api, { formatTL, formatDate } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const STATUS = {
  OPEN: { label: "Açık", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  CLOSED: { label: "Kapalı", cls: "bg-stone-200 text-stone-700 border-stone-300" },
};

function fmtDuration(sec) {
  if (!sec) return "-";
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  return `${h}s ${m}dk`;
}

export default function Shifts() {
  const { isAdmin } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ status: "", cashier_id: "" });

  const load = () => {
    const params = {};
    if (f.status) params.status = f.status;
    if (f.cashier_id) params.cashier_id = f.cashier_id;
    setLoading(true);
    api.get("/shifts", { params }).then((r) => setItems(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [f.status]);

  return (
    <div data-testid="shifts-root">
      <div className="mb-6 flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="font-mono-code text-[10px] tracking-[0.3em] text-stone-500">OPERASYON</div>
          <h1 className="font-serif-display text-3xl sm:text-4xl text-stone-900">{isAdmin ? "Vardiyalar" : "Vardiyalarım"}</h1>
        </div>
        <select
          data-testid="shifts-filter-status"
          value={f.status}
          onChange={(e) => setF({ ...f, status: e.target.value })}
          className="px-3 py-2 border border-stone-200 rounded-lg bg-white text-sm"
        >
          <option value="">Tümü</option>
          <option value="OPEN">Açık</option>
          <option value="CLOSED">Kapalı</option>
        </select>
      </div>

      <div className="card-lux overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-stone-50 border-b border-stone-200">
              <tr className="text-xs uppercase tracking-wider text-stone-500">
                <th className="px-3 py-3 text-left">Vardiya</th>
                {isAdmin && <th className="px-3 py-3 text-left">Kasiyer</th>}
                <th className="px-3 py-3 text-left">Açılış</th>
                <th className="px-3 py-3 text-left">Kapanış</th>
                <th className="px-3 py-3 text-right">Süre</th>
                <th className="px-3 py-3 text-right">Satış</th>
                <th className="px-3 py-3 text-right">Net</th>
                <th className="px-3 py-3 text-right">Nakit</th>
                <th className="px-3 py-3 text-right">Havale</th>
                <th className="px-3 py-3 text-right">Beklenen</th>
                <th className="px-3 py-3 text-right">Sayılan</th>
                <th className="px-3 py-3 text-right">Fark</th>
                <th className="px-3 py-3 text-left">Durum</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {loading && <tr><td colSpan={13} className="text-center py-10 text-stone-400">Yükleniyor…</td></tr>}
              {!loading && items.length === 0 && <tr><td colSpan={13} className="text-center py-14 text-stone-500">Vardiya kaydı yok.</td></tr>}
              {items.map((s) => {
                const st = STATUS[s.status] || STATUS.CLOSED;
                const diff = s.cash_difference;
                return (
                  <tr key={s.id} data-testid={`shift-row-${s.shift_number}`} className="hover:bg-amber-50/30 cursor-pointer" onClick={() => nav(`/vardiyalar/${s.id}`)}>
                    <td className="px-3 py-3 font-mono-code text-sm text-amber-800 font-semibold">{s.shift_number}</td>
                    {isAdmin && <td className="px-3 py-3 text-sm">{s.cashier_name}</td>}
                    <td className="px-3 py-3 text-xs text-stone-600 font-mono-code">{formatDate(s.opened_at)}</td>
                    <td className="px-3 py-3 text-xs text-stone-600 font-mono-code">{s.closed_at ? formatDate(s.closed_at) : "-"}</td>
                    <td className="px-3 py-3 text-right text-xs font-mono-code">{fmtDuration(s.duration_seconds)}</td>
                    <td className="px-3 py-3 text-right font-mono-code text-sm">{s.sales_count}</td>
                    <td className="px-3 py-3 text-right font-mono-code text-sm font-semibold text-amber-800">{formatTL(s.net)}</td>
                    <td className="px-3 py-3 text-right font-mono-code text-xs">{formatTL(s.cash_sales)}</td>
                    <td className="px-3 py-3 text-right font-mono-code text-xs">{formatTL(s.transfer_sales)}</td>
                    <td className="px-3 py-3 text-right font-mono-code text-xs">{formatTL(s.expected_cash)}</td>
                    <td className="px-3 py-3 text-right font-mono-code text-xs">{s.closing_cash_counted != null ? formatTL(s.closing_cash_counted) : "-"}</td>
                    <td className={`px-3 py-3 text-right font-mono-code text-xs font-semibold ${diff == null ? "text-stone-400" : diff === 0 ? "text-stone-800" : diff < 0 ? "text-red-700" : "text-emerald-700"}`}>
                      {diff == null ? "-" : diff === 0 ? "0,00" : (diff > 0 ? "+" : "") + formatTL(diff)}
                    </td>
                    <td className="px-3 py-3">
                      <span className={`inline-flex text-[11px] px-2 py-0.5 rounded-full border font-medium ${st.cls}`}>{st.label}</span>
                      {s.force_closed && <div className="text-[10px] text-red-700 mt-1">Yönetici Kapatma</div>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
